import gsap from 'gsap';
import './intro.css';
const WORDS = ['WELCOME', 'TO', 'THE', 'FUTURE', 'OF', 'IT', 'SOLUTION'];
function buildOverlay() {
    const overlay = document.createElement('div');
    overlay.id = 'intro-overlay';
    const message = document.createElement('div');
    message.id = 'intro-message';
    overlay.appendChild(message);
    document.body.appendChild(overlay);
    return { overlay, message };
}
function playWelcomeMessage(message) {
    const timeline = gsap.timeline();
    let time = 0;
    WORDS.forEach((word, i) => {
        const splitIndex = word.length === 1 ? 0 : Math.floor(word.length / 2);
        const el = document.createElement('h3');
        el.innerHTML =
            word.slice(0, splitIndex) +
                `<span>${word[splitIndex]}</span>` +
                word.slice(splitIndex + 1);
        message.appendChild(el);
        const isFirst = i === 0;
        const isLast = i === WORDS.length - 1;
        const holdTime = isFirst ? 0.35 : isLast ? 0.45 : 0.3;
        gsap.set(el, { autoAlpha: 0, scale: isFirst ? 2 : 1 });
        timeline
            .to(el, { duration: 0.15, autoAlpha: 1, scale: 1 }, time)
            .to(el, { duration: 0.1, autoAlpha: 0, scale: isLast ? 0 : 1 }, `+=${holdTime}`);
        time += 0.5;
    });
    return timeline;
}
/**
 * Plays the intro splash (logo/welcome text) on every load, then reveals
 * whatever is already rendered behind it (the 3D Application keeps loading underneath).
 */
export function runIntro(onDone) {
    const { overlay, message } = buildOverlay();
    const timeline = playWelcomeMessage(message);
    timeline.call(() => {
        overlay.classList.add('intro-hidden');
        onDone();
        overlay.addEventListener('transitionend', () => {
            overlay.remove();
        }, { once: true });
    });
}
